module.exports = __webpack_public_path__ + "img/taoyuan-4.6be62002.jpg";